const CheckedIcon = ({ width = 14, height = 12, color = 'currentColor' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5999 8.9251L1.4499 5.7751L0.399902 6.8251L4.5999 11.0251L13.5999 2.0251L12.5499 0.975098L4.5999 8.9251Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckedIcon;
